import * as React from 'react';

import { Accordion } from '@cian/ui-kit';

import * as styles from './FiltersGroup.css';

interface IFiltersGroupProps {
  title: string;
}

export const FiltersGroup = ({ title, children }: React.PropsWithChildren<IFiltersGroupProps>) => {
  return (
    <div className={styles['container']}>
      <Accordion
        items={[
          {
            content: <div className={styles['content']}>{children}</div>,
            title,
            defaultOpen: true,
          },
        ]}
        size="L"
      />
    </div>
  );
};
